module.exports = __webpack_public_path__ + "img/validate-account.10fafaa4.svg";